import React from 'react';
import { Modal, Button } from 'react-bootstrap';

function CompletePOModal({ show, onHide, onConfirm, title, message }) {
    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
        >
            <Modal.Header closeButton className="bg-warning">
                <Modal.Title>
                    <i className="fas fa-exclamation-triangle me-2"></i>
                    {title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="alert alert-warning">
                    <h5>{message}</h5>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button 
                    variant="secondary" 
                    onClick={onHide}
                >
                    Cancel
                </Button>
                <Button 
                    variant="warning" 
                    onClick={onConfirm}
                >
                    Yes, Complete PO
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default CompletePOModal; 